// extracted by mini-css-extract-plugin
export var accesDirectContainer = "acces-direct-module--acces-direct-container--01e1c";
export var accesDirectDescription = "acces-direct-module--acces-direct-description--757a8";
export var accesDirectItem = "acces-direct-module--acces-direct-item--d102a";
export var accesDirectItemDescription = "acces-direct-module--acces-direct-item-description--fcecf";
export var accesDirectItemImg = "acces-direct-module--acces-direct-item-img--118a5";
export var accesDirectTitle = "acces-direct-module--acces-direct-title--5b576";
export var editButton = "acces-direct-module--edit-button--cc29e";
export var editButtonTitle = "acces-direct-module--edit-button-title--9fdb5";